<div class="modal-overlay" *ngIf="showModal">
  <div class="popup-modal">
    <img
      src="assets/images/tier/close.svg"
      class="modal-close"
      (click)="closePopup()"
      alt="Close"
    />
    <div class="unlocked-popup">
      <!-- Tier Badge -->
      <div class="tier-badge">
        <img [src]="getTierLogoPath()" [alt]="getTierName()" class="tier-logo" />
      </div>

      <!-- Title Section -->
      <div class="title-section">
        <h2 class="main-title">
          You unlocked {{ getTierName() }} tier at TRENDS 🎉
        </h2>
        <p class="subtitle" *ngIf="shouldShowSubtitle()">{{ getSubtitle() }}</p>
      </div>

      <!-- Rewards List -->
      <div class="rewards-container" *ngIf="getRewards().length > 0">
        <div
          class="reward-item"
          *ngFor="let reward of getRewards(); let last = last"
        >
          <div class="reward-content">
            <div class="reward-icon" [style.background-color]="getTierIconBgColor()">
              <img [src]="reward.icon" [alt]="reward.name" *ngIf="reward.icon" />
            </div>
            <div class="reward-text">
              <span class="reward-name">{{ reward.name }}</span>
              <span class="reward-description" *ngIf="reward.description">{{ reward.description }}</span>
            </div>
          </div>
          <!-- <img
            src="assets/images/dashboard/right-arrow.svg"
            alt="Navigate"
            class="reward-arrow"
          /> -->
          <div class="reward-divider" *ngIf="!last"></div>
        </div>
      </div>

      <!-- Earning Info (for Red tier) -->
      <div class="earning-info" *ngIf="tierData?.earningInfo">
        <p>{{ tierData?.earningInfo }}</p>
      </div>

      <!-- Additional Benefits (for Black tier) -->
      <div class="additional-benefits" *ngIf="tierData?.additionalBenefits">
        <p>{{ tierData?.additionalBenefits }}</p>
      </div>

      <!-- CTA Button -->
      <div class="cta-section">
        <button
          class="explore-button"
          style="background-color: #003380; color: #FFFFFF;"
          (click)="closePopup()"
        >
          EXPLORE {{ getTierName().toUpperCase() }} TIER
        </button>
      </div>
    </div>
  </div>
</div>
